import { findBestMatch } from './string-similarity.utils';

export type IndustryMapVendor = 'PL Rating' | 'EZLynx' | 'AppliedEpic' | 'Applied';

const plRatingIndustries = [
  {
    label: 'Accountant',
    value: 'ACT',
    occupations: [
      'Account Executive',
      'Account/Auditor',
      'Bookkeeper',
      'Controller',
    ],
  },
  {
    label: 'Administrator/Director',
    value: 'ADD',
    occupations: ['Director/Administrator'],
  },
  {
    label: 'Administrative',
    value: 'ADM',
    occupations: ['Administrative Assistant', 'Superintendent'],
  },
  {
    label: 'Agronomist',
    value: 'AGR',
    occupations: [
      'Agriculture Inspector/Grader',
      'Arborist',
      'Clerk',
      'Equipment Operator',
      'Farm/Ranch Worker',
      'Florist',
      'Landscaper',
      'Landscaper/Nursery Worker',
      'Other',
    ],
  },
  {
    label: 'Airline Personnel',
    value: 'AIR',
    occupations: [
      'Air Traffic Control',
      'Airport Operations Crew',
      'Airport Security Officer',
    ],
  },
  {
    label: 'Architect',
    value: 'AR',
    occupations: ['Architect', 'Drafter'],
  },
  {
    label: 'Artist (Without Other Profession)',
    value: 'ART',
    occupations: ['Artist/Animator', 'Other'],
  },
  {
    label: 'Athlete - Professional',
    value: 'ATH',
    occupations: [
      'Coach',
      'Other',
      'Professional Athlete',
      'Trainer/Instructor',
      'Umpire/Referee',
    ],
  },
  {
    label: 'Actuary',
    value: 'ATY',
    occupations: ['Actuarial Clerk', 'Actuary'],
  },
  {
    label: 'Automobile Mechanic',
    value: 'AUM',
    occupations: ['Mechanic'],
  },
  {
    label: 'Automobile Sales/Dealer',
    value: 'AUS',
    occupations: ['Other'],
  },
  {
    label: 'Bank/Financial Institution - Administration',
    value: 'BAD',
    occupations: [
      'Accountant/Auditor',
      'Banking/Finance/Real Estate',
      'Director/Administrator',
      'Investment Banker',
      'Investor',
      'Loan/Escrow Processor',
      'Other',
    ],
  },
  {
    label: 'Bank/Financial Institution - Clerical',
    value: 'BFI',
    occupations: ['Clerk', 'Collections', 'Receptionist/Secretary', 'Teller'],
  },
  {
    label: 'Bank/Financial Institution - Management',
    value: '',
    occupations: [
      'Branch Manager',
      'Investment Banker',
      'Investor',
      'Manager - Credit/Loan',
      'Other',
    ],
  },
  {
    label: 'Barber, Hairdresser',
    value: 'BRB',
    occupations: ['Hair Stylist/Barber'],
  },
  {
    label: 'Chartered Accountant',
    value: 'CA',
    occupations: ['Other'],
  },
  {
    label: 'Cashier',
    value: 'CAS',
    occupations: ['Other'],
  },
  {
    label: 'Crown Corporation Employee',
    value: 'CCE',
    occupations: ['Other'],
  },
  {
    label: 'Craftsman',
    value: 'CFG',
    occupations: [
      'Bricklayer/Mason',
      'Carpenter',
      'Carpet Installer',
      'Floor Layer/Finisher',
      'Furniture Finisher',
      'Handyman',
    ],
  },
  {
    label: 'Consultant - Human Resources',
    value: 'CHM',
    occupations: ['H.R. Representative'],
  },
  {
    label: 'Clergy',
    value: 'CL',
    occupations: ['Clergy', 'Clergy, Church Workers'],
  },
  {
    label: 'Computer - Analyst, Consultant, Programmer, etc.',
    value: 'CMP',
    occupations: [
      'Engineer - Hardware',
      'Engineer - Software',
      'Engineer - Systems',
      'Information/Technology',
      'Manager - Systems',
      'Network Administrator',
      'Other',
      'Programmer',
      'Project Coordinator',
      'Support Technician',
      'Systems Security',
      'Technical Writer',
      'Web Developer',
    ],
  },
  {
    label: 'Consultant - Other',
    value: 'COT',
    occupations: ['Consultant'],
  },
  {
    label: 'Certified Public Accountant',
    value: 'CPA',
    occupations: ['Other'],
  },
  {
    label: 'Carpenter',
    value: 'CRP',
    occupations: ['Carpenter'],
  },
  {
    label: 'Courts e.g. Bailiff, Clerk, Reporter, Stenographer, etc.',
    value: 'CRT',
    occupations: [
      'Bailiff',
      'Clerical/Technical',
      'Clerk',
      'Court Clerk/Reporter',
      'Examiner',
      'Leagal Assistant/Secretary',
      'Legal Profession',
      'Legal/Law Enforcement/Security',
      'Paralegal/Law Clerk',
      'Process Server',
    ],
  },
  {
    label: 'Civil Service',
    value: 'CS',
    occupations: [
      'Commissioner',
      'Council member',
      'Judge/Hearing Officer',
      'Legislator',
      'Mayor/City Manger',
      'Politicians, Judges',
    ],
  },
  {
    label: 'Consultant - Training',
    value: 'CTR',
    occupations: ['Trainer/Instructor'],
  },
  {
    label: 'Daycare Worker, Provider',
    value: 'DAY',
    occupations: ['Child/Daycare Worker', 'Nanny'],
  },
  {
    label: 'Dentist',
    value: 'DEN',
    occupations: ['Dentist'],
  },
  {
    label: 'Dental Hygenist',
    value: 'DHY',
    occupations: [
      'Assistant - Medical/Dental/Veterinarian',
      'Dental Hygienist',
    ],
  },
  {
    label: 'Dietician, Nutritionist',
    value: 'DIE',
    occupations: ['Assistant - Medical/Dental/Veterinarian', 'Other'],
  },
  {
    label: 'Disabled/Unable to work',
    value: 'DIS',
    occupations: ['Disabled'],
  },
  {
    label: 'Driver - Local Delivery',
    value: 'DRL',
    occupations: ['Driver - Truck/Delivery'],
  },
  {
    label: 'Driver - Long Haul, Mover',
    value: 'DRM',
    occupations: ['Driver - Truck/Delivery'],
  },
  {
    label: 'Driver - Public Transportation',
    value: 'DRP',
    occupations: ['Driver - Bus/Streetcar'],
  },
  {
    label: 'Driver - Taxi, Chauffeur, Instructor',
    value: 'DRT',
    occupations: ['Driver - Taxi/Limo'],
  },
  {
    label: 'Electrician',
    value: 'ELE',
    occupations: ['Electrician/Linesman', 'Regulator'],
  },
  {
    label: 'Engineer',
    value: 'ENG',
    occupations: [
      'Engineer',
      'Engineer/Architect/Science/Math',
      'Surveyor/Mapmaker',
    ],
  },
  {
    label: 'Entertainment Field e.g. Actor, Musician, etc.',
    value: 'ENT',
    occupations: [
      'Actor',
      'Announcer/Broadcaster',
      'Artist/Animator',
      'Broadcasting',
      'Choreography/Dancer',
      'Composer/Director',
      'Curator',
      'Editors, Photography, PR, Writers, Reporter',
      'Entertainers, Producers',
      'Event Manager/Promoter',
      'Journalist/Reporter',
      'Musician/Singer',
      'Other',
      'Producer',
      'Production',
    ],
  },
  {
    label: 'Executive',
    value: 'EXE',
    occupations: ['Executive'],
  },
  {
    label: 'Factory Worker, Machine Operator, Tool & Die Worker',
    value: 'FAC',
    occupations: [
      'Factory Worker',
      'Food Production/Packing',
      'Forklift Operator',
      'Inspector',
      'Machine Operator',
      'Manufacturing/Production',
      'Other',
      'Packer',
      'Plant Manager',
      'Quality Control',
      'Refining Operator',
      'Shipping/Receiving Clerk',
      'Shoemaker',
      'Textile Worker',
      'Upholsterer',
    ],
  },
  {
    label: 'Firefighter',
    value: 'FF',
    occupations: [
      'Fire & Rescue',
      'Fire Chief',
      'Fire Fighter/Supervisor',
      'Paramedic/E.M. Technician',
    ],
  },
  {
    label: 'Financial Advisor, Broker, Economist',
    value: 'FIN',
    occupations: [
      'Agent/Broker',
      'Anaylst/Broker',
      'Financial Advisor',
      'Trader, Financial Instruments',
    ],
  },
  {
    label: 'Fitness, Health Employee',
    value: 'FIT',
    occupations: [
      'Activity/Recreation Assistant',
      'Assistant - Medical/Dental/Veterinarian',
      'Other',
      'Sports/Recreation',
    ],
  },
  {
    label: 'Flagged Occupation',
    value: 'FL',
    occupations: ['Other'],
  },
  {
    label: 'Flight Attendant',
    value: 'FLA',
    occupations: ['Flight Attendant'],
  },
  {
    label: 'Food Industry - Other e.g. Butcher, Slaughterer',
    value: 'FOD',
    occupations: ['Baker'],
  },
  {
    label: 'Forest Employee',
    value: 'FOR',
    occupations: [
      'Agriculture/Forestry/Fishing',
      'Gaming Officer/Investigator',
      'Logger',
      'Mill worker',
      'Park Ranger',
      'Ranger',
      'Timber Grader/Scale',
    ],
  },
  {
    label: 'Farmer',
    value: 'FRM',
    occupations: ['Farm/Ranch Worker', 'Farmer'],
  },
  {
    label: 'Fisherman',
    value: 'FSH',
    occupations: ['Fisherman', 'Longshoreman', 'Mate/Sailor'],
  },
  {
    label: 'General Contractor',
    value: 'GC',
    occupations: [
      'Concrete Worker',
      'Construction',
      'Construction/Energy Trades',
      'Contractor',
      'Crane Loader/Operator',
      'Crane Operator',
      'Equipment Operator',
      'Floor Layer/Finisher',
      'Manager - Project',
    ],
  },
  {
    label: 'Graphic Designer, Printer',
    value: 'GDP',
    occupations: ['Art/Design/Media', 'Artist/Animator', 'Printer/Bookbinder'],
  },
  {
    label: 'Homemaker',
    value: 'HO',
    occupations: ['Homemaker'],
  },
  {
    label: 'Hotel, Motel Worker',
    value: 'HOT',
    occupations: ['Bellhop/Porter', 'Concierge', 'Desk Clerk', 'Valet'],
  },
  {
    label: 'Horticulture',
    value: 'HRT',
    occupations: ['Arborist'],
  },
  {
    label: 'Insurance - Agent, Broker',
    value: 'IAB',
    occupations: ['Agent/Broker', 'Insurance'],
  },
  {
    label: 'Insurance - Adjuster',
    value: 'IAD',
    occupations: ['Clainms Adjuster', 'Insurance'],
  },
  {
    label: 'Insurance - Underwriter',
    value: 'IUW',
    occupations: ['Insurance', 'Underwriter'],
  },
  {
    label: 'Laborer - Unskilled',
    value: 'LAB',
    occupations: [
      'Domestic Worker',
      'Laborer',
      'Metalworker',
      'Shipping/Receiving Clerk',
    ],
  },
  {
    label: 'Lawyer',
    value: 'LAW',
    occupations: ['Attorney', 'Paralegal/Law Clerk'],
  },
  {
    label: 'Librarian',
    value: 'LIB',
    occupations: ['Clerk', 'Curator', 'Librairian/Curator'],
  },
  {
    label: 'Manager',
    value: 'MGR',
    occupations: [
      'Management',
      'Manager - Credit/Loan',
      'Manager - Department/Store',
      'Manager - District',
      'Manager - Finance',
      'Manager - Fitness Club',
      'Manager - General Operations',
      'Manager - H.R./Public Relations',
      'Manager - Marketing/Sales',
      'Manager - Portfolio/Production',
      'Manager - Propert',
    ],
  },
  {
    label: 'Military (Armed Forces)',
    value: 'MI',
    occupations: [
      'Enlisted Military Personnel (E1-4)',
      'Government/Military',
      'Mate/Sailor',
      'Military, Commissioned',
      'NCO (E5-9)',
      'Officer - Commissioned',
      'Officer - Warrant',
    ],
  },
  {
    label: 'Miner',
    value: 'MIN',
    occupations: ['Occupation', 'Miner'],
  },
  {
    label: 'Marketing Employee',
    value: 'MKT',
    occupations: ['Marketing Researcher'],
  },
  {
    label: 'Maintenance, Janitor, Cleaner',
    value: 'MNT',
    occupations: [
      'Building Maintenance Engineer',
      'Custodian/Janitor',
      'Field Service Technician',
      'Housekeeper',
      'Housekeeper/Maid',
      'Landscape/Grounds Maintenance',
      'Maintenance Mechanic',
      'Maintenance/Repair/Housekeeping',
      'Other',
    ],
  },
  {
    label:
      'Medical Specialist e.g. Anaesthetist, Chiropractor, Podiatrist, etc.',
    value: 'MSP',
    occupations: [
      'Assistant - Medical/Dental/Veterinarian',
      'Client Care Worker',
      'Clinical Data Coordinator',
      'Masseuse',
      'Medical Profession',
      'Medical/Social Services/Religion',
      'Mortician',
      'Social Worker',
      'Sociologist',
    ],
  },
  {
    label: 'Nurse',
    value: 'NRS',
    occupations: [
      'Assistant - Medical/Dental/Veterinarian',
      'Nurse - C.N.A.',
      'Nurse - LPN',
      'Nurse - RN',
      'Nurse Practicioner',
    ],
  },
  {
    label: 'Notary',
    value: 'NTR',
    occupations: ['Other'],
  },
  {
    label: 'Office, Sales',
    value: 'OF',
    occupations: [
      'Buyer',
      'Clerk',
      'Customer Service Representative',
      'Marketing Researcher',
      'Messenger/Courier',
      'Office & Sales',
      'Office Worker, non-management',
      'Receptionist/Secretary',
      'Sales - Counter/Rental',
      'Sales - Home Based',
      'Sales - Manufacture Rep',
      'Sales - Other',
      'Sales - Retail/Wholesale',
    ],
  },
  {
    label: 'Optician',
    value: 'OPI',
    occupations: ['Assistant - Medical/Dental/Veterinarian', 'Other'],
  },
  {
    label: 'Optometrist, Opthamologist',
    value: 'OPT',
    occupations: ['Optometrist'],
  },
  {
    label: 'Other',
    value: 'OT',
    occupations: [
      'Camp Counselor/Lead',
      'Communication, Utilities',
      'Delivery',
      'Designer',
      'Desk Clerk',
      'Dispatcher',
      'Dry Cleaner/Laundry',
      'Food Delivery w/per vehicle',
      'Government Employee',
      'Hospice Volunteer',
      'Hospitality/Food Service',
      'Jeweler',
      'Life Guard',
      'Liquor & Beer Industry',
      'Manicurist',
      'Mathem',
    ],
  },
  {
    label: 'Professional, Advanced degree',
    value: 'PAD',
    occupations: [
      'Chief Executive',
      'Judge/Hearing Officer',
      'Professional - Specialized',
      'Support Services',
    ],
  },
  {
    label: 'Professional, College degree',
    value: 'PO',
    occupations: [
      'Professional - All Other',
      'Professional - General',
      'Social Worker',
    ],
  },
  {
    label: 'Photographer, Photography Studio',
    value: 'PHO',
    occupations: ['Editors, Photography, PR, Writers, Reporter'],
  },
  {
    label: 'Pharmacist',
    value: 'PHR',
    occupations: ['Pharmacist'],
  },
  {
    label: 'Physician',
    value: 'PHY',
    occupations: ['Doctor'],
  },
  {
    label: 'Pilot',
    value: 'PLT',
    occupations: ['Pilot/Captain/Engineer'],
  },
  {
    label: 'Painter, Plasterer',
    value: 'PNT',
    occupations: ['Painter', 'Plaster/Drywall/Stucco'],
  },
  {
    label: 'Professional Manager',
    value: 'PO',
    occupations: [
      'Management',
      'Manager - Credit/Loan',
      'Manager - Department/Store',
      'Manager - District',
      'Manager - Finance',
      'Manager - Fitness Club',
      'Manager - General Operations',
      'Manager - H.R./Public Relations',
      'Manager - Marketing/Sales',
      'Manager - Portfolio/Production',
      'Manager - Propert',
    ],
  },
  {
    label: 'Police Officer',
    value: 'POL',
    occupations: [
      'Airport Security Officer',
      'Animal Control Officer',
      'Corrections Officer',
      'Deputy Sheriff',
      'Federal Agent/Marshall',
      'Highway Patrol Officer',
      'Law Enforcemtn Including Police & Fire',
      'Other',
      'Police Chief',
      'Police Detective/Investigator',
      'Police Officer/Supervisor',
      'Private Inve',
    ],
  },
  {
    label: 'Professor',
    value: 'PRO',
    occupations: ['Professor, College', 'Teacher, College'],
  },
  {
    label: 'Postal Worker',
    value: 'PST',
    occupations: [
      'Other',
      'Postmaster',
      'Rural Mail Carriers',
      'US Postal Worker',
    ],
  },
  {
    label: 'Public Transportation Worker - Other Than Airline',
    value: 'PTO',
    occupations: ['Other', 'Railroad Worker', 'Subway/Light Rail Operator'],
  },
  {
    label: 'Real Estate Agent',
    value: 'REA',
    occupations: ['Agent/Broker', 'Realtor'],
  },
  {
    label: 'Retired',
    value: 'RET',
    occupations: ['Retired'],
  },
  {
    label: 'Restaurant, Bar - Owner, Employee e.g. Waiter, Bartender, etc.',
    value: 'RSB',
    occupations: [
      'Bartender',
      'Bus Person',
      'Concessinaire',
      'Delivery',
      'Dishwasher',
      'Host/Maitre d',
      'Restaurant/Hotel Services',
      'Waiter/Waitress',
      'Wine Steward',
    ],
  },
  {
    label: 'Restaurant, Bar - Chef, Cook, Caterer',
    value: 'RSC',
    occupations: [
      'Caterer',
      'Chef',
      'Cook - Restaurant/Cafeteria',
      'Cook/Worker - Fast Food',
    ],
  },
  {
    label: 'Retail Sales Person',
    value: 'RTS',
    occupations: [
      'Business/Sales/Office',
      'Retail',
      'Sales - Counter/Rental',
      'Sales - Homebased',
      'Sales - Manufacture Rep',
      'Sales - Other',
      'Sales - Retail/Wholesale',
      'Sales - Route/Vendor',
      'Sales (Travel Only)',
      'Sales Agent/Representative',
      'Sales - Ticket/Membership',
    ],
  },
  {
    label: 'Salaried',
    value: 'SA',
    occupations: ['Other'],
  },
  {
    label: 'Salesperson - Commercial',
    value: 'SAL',
    occupations: ['Other', 'Sales Agent/Representative'],
  },
  {
    label: 'Scientist',
    value: 'SC',
    occupations: ['Scientist'],
  },
  {
    label: 'School Teacher',
    value: 'SCT',
    occupations: [
      'Educators, Teachers',
      'Graduate Teaching/Assistant',
      'Instructor-Vocation',
      'Other',
      'Teacher, College',
      'Teacher, K-12',
      'Teaching Assistant/Aide',
      'Tutor',
    ],
  },
  {
    label: 'Self-Employed',
    value: 'SE',
    occupations: [
      'Concessionaire',
      'Self-Employed - Repaired',
      'Self-Employed - Service',
      'Self-Employed - All Other',
      'Self-Employed - Construction',
      'Self-Employed - Volunteer',
    ],
  },
  {
    label: 'Security Officer, Worker',
    value: 'SEC',
    occupations: ['Other', 'Security Guard'],
  },
  {
    label: 'Skilled, Semi-Skilled',
    value: 'SK',
    occupations: [
      'Crane Loader/Operator',
      'Elevator Technician/Installer',
      'Equipment Operator',
      'Floor Layer/Finisher',
      'Furniture Finisher',
      'Heat/Air Technician',
      'Inspector',
      'Laborer',
      'Mechanic',
      'Oil/Gas Driller/Rig Operator',
      'Other',
      'Plaster/Drywall/Stucco',
      'Plumber',
      'Roofer',
      'Semi-Skilled',
      'Skill/Unski',
    ],
  },
  {
    label: 'Seamstress',
    value: 'SMS',
    occupations: ['Tailor/Custom Sewer'],
  },
  {
    label: 'Supervisor, Foreman',
    value: 'SPR',
    occupations: ['Foreman/Supervisor', 'Supervisor'],
  },
  {
    label: 'Spouse at Home',
    value: 'SPS',
    occupations: ['Housewives/Househusbands'],
  },
  {
    label: 'Student',
    value: 'ST',
    occupations: [
      'Graduate Student',
      'High School',
      'Other',
      'Student',
      'Undergraduate',
    ],
  },
  {
    label: 'Technicians - Research, Medical',
    value: 'TEC',
    occupations: [
      'Assistant - Medical/Dental/Veterinarian',
      'Audio-Visual Tech',
      'Other',
      'Research Program Director',
      'Researcher',
      'Support Technician',
      'Technician',
    ],
  },
  {
    label: 'Technical /Supervisory',
    value: 'TES',
    occupations: ['Technical/Supervisory'],
  },
  {
    label: 'Therapist',
    value: 'THR',
    occupations: ['Counselor', 'Therapist'],
  },
  {
    label: 'Tradesman',
    value: 'TRD',
    occupations: [
      'Boiler Operator/Maker',
      'Bricklayer/Mason',
      'Carpenter',
      'Carpet Installer',
      'Floor Layer/Finisher',
      'Heat/Air Technician',
      'Maintenance Mechanic',
      'Mechanic',
      'Other',
      'Plaster/Drywall/Stucco',
      'Plumber',
      'Printer/Bookbinder',
      'Roofer',
      'Shoemaker',
      'Upholsterer',
    ],
  },
  {
    label: 'Unknown',
    value: 'UN',
    occupations: ['Unknown'],
  },
  {
    label: 'Unemployed',
    value: 'UNEM',
    occupations: ['Unemployed'],
  },
  {
    label: 'Unskilled',
    value: 'US',
    occupations: ['Unskilled'],
  },
  {
    label: 'Veterinarian',
    value: 'VET',
    occupations: [
      'Assistant - Medical/Dental/Veterinarian',
      'Pet Services',
      'Veterinarian',
    ],
  },
  {
    label: 'Writer, Publisher',
    value: 'WRT',
    occupations: [
      'Author/Writer',
      'Editors, Photography, PR, Writers, Reporter',
      'Printer/Bookbinder',
      'Publishing',
      'Technical Writer',
    ],
  },
];

const ezlynxIndustries = [
  {
    label: 'Homemaker/House person',
    value: 'Homemaker/House person',
    occupations: ['Homemaker/House person'],
  },
  { label: 'Retired', value: 'Retired', occupations: ['Retired'] },
  { label: 'Disabled', value: 'Disabled', occupations: ['Disabled'] },
  { label: 'Unemployed', value: 'Unemployed', occupations: ['Unemployed'] },
  {
    label: 'Student',
    value: 'Student',
    occupations: ['Graduate Student', 'High school', 'Other', 'Undergraduate'],
  },
  {
    label: 'Agriculture/Forestry/Fishing',
    value: 'Agriculture/Forestry/Fishing',
    occupations: [
      'Agriculture Inspector/Grader',
      'Arborist',
      'Clerk',
      'Equipment Operator',
      'Farm/Ranch Owner',
      'Farm/Ranch Worker',
      'Fisherman',
      'Florist',
      'Laborer/Worker',
      'Landscaper/Nursery Worker',
      'Landscaper',
      'Logger',
      'Mill worker',
      'Other',
      'Ranger',
      'Supervisor',
      'Timber Grader/Scale',
    ],
  },
  {
    label: 'Art/Design/Media',
    value: 'Art/Design/Media',
    occupations: [
      'Actor',
      'Administrative Assistant',
      'Announcer/Broadcaster',
      'Artist/Animator',
      'Author/Writer',
      'Choreography/Dancer',
      'Clerk',
      'Composer/Director',
      'Curator',
      'Designer',
      'Editor',
      'Journalist/Reporter',
      'Musician/Singer',
      'Other',
      'Printer',
      'Producer',
      'Production Crew',
      'Projectionist',
      'Receptionist/Secretary',
      'Ticket Sales/Usher',
    ],
  },
  {
    label: 'Banking/Finance/Real Estate',
    value: 'Banking/Finance/Real Estate',
    occupations: [
      'Accountant/Auditor',
      'Administrative Assistant',
      'Analyst/Broker',
      'Bookkeeper',
      'Branch Manager',
      'Clerk',
      'Collections',
      'Consultant',
      'Controller',
      'CSR/Teller',
      'Director/Administrator',
      'Executive',
      'Financial Advisor',
      'Investment Banker',
      'Investor',
      'Loan/Escrow Processor',
      'Manager-Credit/Loan',
      'Manager-Portfolio/Production',
      'Manager-Property',
      'Other',
      'Realtor',
      'Receptionist/Secretary',
      'Sales Agent/Representative',
      'Trader, Financial Instruments',
      'Underwriter',
    ],
  },
  {
    label: 'Business/Sales/Office',
    value: 'Business/Sales/Office',
    occupations: [
      'Account Executive',
      'Administrative Assistant',
      'Buyer',
      'Clerk-Office',
      'Consultant',
      'Customer Service Representative',
      'Director/Administrator',
      'Executive',
      'H.R. Representative',
      'Marketing Researcher',
      'Messenger/Courier',
      'Manager - District',
      'Manager - Finance',
      'Manager - Department/Store',
      'Manager - General Operations',
      'Manager - H.R./Public Relations',
      'Manager - Marketing/Sales',
      'Manager/Supervisor - Office',
      'Other',
      'Receptionist/Secretary',
      'Sales-Counter/Rental',
      'Sales-Home Based',
      'Sales-Manufacture Rep',
      'Sales-Retail/Wholesale',
      'Sales-Route/Vendor',
    ],
  },
  {
    label: 'Construction/Energy Trades',
    value: 'Construction/Energy Trades',
    occupations: [
      'Boiler Operator/Maker',
      'Bricklayer/Mason',
      'Carpenter',
      'Carpet Installer',
      'Concrete Worker',
      'Construction - Project Manager',
      'Contractor',
      'Crane Operator',
      'Electrician/Linesman',
      'Elevator Technician/Installer',
      'Equipment Operator',
      'Floor Layer/Finisher',
      'Foreman/Supervisor',
      'Handyman',
      'Heat/Air Technician',
      'Inspector',
      'Laborer/Worker',
      'Metalworker',
      'Miner',
      'Oil/Gas Driller/Rig Operator',
      'Other',
      'Painter',
      'Plaster/Drywall/Stucco',
      'Plumber',
      'Roofer',
    ],
  },
  {
    label: 'Education/Library',
    value: 'Education/Library',
    occupations: [
      'Administrative Assistant',
      'Audio-Visual Tech.',
      'Child/Daycare Worker',
      'Clerk',
      'Counselor',
      'Graduate Teaching Assistant',
      'Instructor-Vocation',
      'Librarian/Curator',
      'Other',
      'Professor, College',
      'Receptionist/Secretary',
      'Superintendent',
      'Teacher, College',
      'Teacher, K-12',
      'Teaching Assistant/Aide',
      'Tutor',
    ],
  },
  {
    label: 'Engineer/Architect/Science/Math',
    value: 'Engineer/Architect/Science/Math',
    occupations: [
      'Actuary',
      'Administrative Assistant',
      'Analyst',
      'Architect',
      'Clerk',
      'Clinical Data Coordinator',
      'Drafter',
      'Engineer',
      'Manager-Project',
      'Manager-R&D',
      'Mathematician',
      'Other',
      'Receptionist/Secretary',
      'Research Program Director',
      'Researcher',
      'Scientist',
      'Sociologist',
      'Surveyor/Mapmaker',
      'Technician',
    ],
  },
  {
    label: 'Government/Military',
    value: 'Government/Military',
    occupations: [
      'Accountant/Auditor',
      'Administrative Assistant',
      'Analyst',
      'Attorney',
      'Chief Executive',
      'Clerk',
      'Commissioner',
      'Council member',
      'Director/Administrator',
      'Enlisted Military Personnel (E1-4)',
      'Legislator',
      'Mayor/City Manager',
      'Meter Reader',
      'NCO (E5-9)',
      'Officer-Commissioned',
      'Officer-Warrant',
      'Other',
      'Park Ranger',
      'Planner',
      'Postmaster',
      'Receptionist/Secretary',
      'Regulator',
      'US Postal Worker',
    ],
  },
  {
    label: 'Information Technology',
    value: 'Information Technology',
    occupations: [
      'Administrative Assistant',
      'Analyst',
      'Clerk',
      'Director/Administrator',
      'Engineer-Hardware',
      'Engineer-Software',
      'Engineer-Systems',
      'Executive',
      'Manager-Systems',
      'Network Administrator',
      'Other',
      'Programmer',
      'Project Coordinator',
      'Receptionist/Secretary',
      'Support Technician',
      'Systems Security',
      'Technical Writer',
      'Web Developer',
    ],
  },
  {
    label: 'Insurance',
    value: 'Insurance',
    occupations: [
      'Accountant/Auditor',
      'Actuarial Clerk',
      'Actuary',
      'Administrative Assistant',
      'Agent/Broker',
      'Analyst',
      'Attorney',
      'Claims Adjuster',
      'Clerk',
      'Commissioner',
      'Customer Service Representative',
      'Director/Administrator',
      'Executive',
      'Other',
      'Product Manager',
      'Receptionist/Secretary',
      'Sales Representative',
      'Underwriter',
    ],
  },
  {
    label: 'Legal/Law Enforcement/Security',
    value: 'Legal/Law Enforcement/Security',
    occupations: [
      'Airport Security Officer',
      'Animal Control Officer',
      'Attorney',
      'Bailiff',
      'Corrections Officer',
      'Court Clerk/Reporter',
      'Deputy Sheriff',
      'Dispatcher',
      'Examiner',
      'Federal Agent/Marshall',
      'Fire Chief',
      'Fire Fighter/Supervisor',
      'Gaming Officer/Investigator',
      'Highway Patrol Officer',
      'Judge/Hearing Officer',
      'Legal Assistant/Secretary',
      'Other',
      'Paralegal/Law Clerk',
      'Police Chief',
      'Police Detective/Investigator',
      'Police Officer/Supervisor',
      'Process Server',
      'Private Investigator/Detective',
      'Security Guard',
      'Sheriff',
    ],
  },
  {
    label: 'Maintenance/Repair/Housekeeping',
    value: 'Maintenance/Repair/Housekeeping',
    occupations: [
      'Building Maintenance Engineer',
      'Custodian/Janitor',
      'Electrician',
      'Field Service Technician',
      'Handyman',
      'Heat/Air Conditioner Repairman',
      'Housekeeper/Maid',
      'Landscape/Grounds Maintenance',
      'Maintenance Mechanic',
      'Mechanic',
      'Other',
    ],
  },
  {
    label: 'Manufacturing/Production',
    value: 'Manufacturing/Production',
    occupations: [
      'Administrative Assistant',
      'Clerk',
      'Factory Worker',
      'Foreman/Supervisor',
      'Furniture Finisher',
      'Inspector',
      'Jeweler',
      'Machine Operator',
      'Other',
      'Packer',
      'Plant Manager',
      'Printer/Bookbinder',
      'Quality Control',
      'Receptionist/Secretary',
      'Refining Operator',
      'Shoemaker',
      'Tailor/Custom Sewer',
      'Textile Worker',
      'Upholsterer',
    ],
  },
  {
    label: 'Medical/Social Services/Religion',
    value: 'Medical/Social Services/Religion',
    occupations: [
      'Administrative Assistant',
      'Assistant - Medic/Dent/Vet',
      'Clergy',
      'Clerk',
      'Client Care Worker',
      'Dental Hygienist',
      'Dentist',
      'Doctor',
      'Hospice Volunteer',
      'Mortician',
      'Nurse - C.N.A.',
      'Nurse - LPN',
      'Nurse - RN',
      'Nurse Practitioner',
      'Optometrist',
      'Other',
      'Paramedic/E.M. Technician',
      'Pharmacist',
      'Receptionist/Secretary',
      'Social Worker',
      'Support Services',
      'Technician',
      'Therapist',
      'Veterinarian',
    ],
  },
  {
    label: 'Personal Care/Service',
    value: 'Personal Care/Service',
    occupations: [
      'Caregiver',
      'Dry Cleaner/Laundry',
      'Hair Stylist/Barber',
      'Housekeeper',
      'Manicurist',
      'Masseuse',
      'Nanny',
      'Other',
      'Pet Services',
      'Receptionist/Secretary',
    ],
  },
  {
    label: 'Restaurant/Hotel Services',
    value: 'Restaurant/Hotel Services',
    occupations: [
      'Baker',
      'Bartender',
      'Bellhop',
      'Bus Person',
      'Caterer',
      'Chef',
      'Concessionaire',
      'Concierge',
      'Cook - Restaurant/Cafeteria',
      'Cook/Worker-Fast Food',
      'Delivery Person',
      'Desk Clerk',
      'Dishwasher',
      'Food Production/Packing',
      'Host/Maitre d',
      'Housekeeper/Maid',
      'Manager',
      'Other',
      'Valet',
      'Waiter/Waitress',
      'Wine Steward',
    ],
  },
  {
    label: 'Sports/Recreation',
    value: 'Sports/Recreation',
    occupations: [
      'Activity/Recreational Assistant',
      'Administrative Assistant',
      'Agent',
      'Athlete',
      'Camp Counselor/Lead',
      'Clerk',
      'Coach',
      'Concessionaire',
      'Director, Program',
      'Event Manager/Promoter',
      'Life Guard',
      'Manager - Fitness Club',
      'Other',
      'Park Ranger',
      'Receptionist/Secretary',
      'Sales-Ticket/Membership',
      'Sports Broadcaster/Journalist',
      'Trainer/Instructor',
      'Umpire/Referee',
    ],
  },
  {
    label: 'Travel/Transportation/Warehousing',
    value: 'Travel/Transportation/Warehousing',
    occupations: [
      'Administrative Assistant',
      'Air Traffic Control',
      'Airport Operations Crew',
      'Bellhop/Porter',
      'Clerk',
      'Crane Loader/Operator',
      'Dispatcher',
      'Driver - Bus/Streetcar',
      'Driver-Taxi/Limo',
      'Driver-Truck/Delivery',
      'Flight Attendant',
      'Forklift Operator',
      'Laborer',
      'Longshoreman',
      'Mate/Sailor',
      'Manager - Warehouse/District',
      'Other',
      'Parking Lot Attendant',
      'Pilot/Captain/Engineer',
      'Railroad Worker',
      'Receptionist/Secretary',
      'Shipping/Receiving Clerk',
      'Subway/Light Rail Operator',
      'Ticket Agent',
      'Transportation Specialist',
    ],
  },
  { label: 'Other', value: 'Other', occupations: ['Other'] },
];

const appliedEpicIndustries = [
{
  label: 'Agriculture/Forestry/Fishing',
  value: 'Agriculture/Forestry/Fishing',
  occupations: ['Agriculture Inspector/Grader', 'Arborist', 'Clerk', 'Equipment Operator', 'Farm/Ranch Owner', 'Farm/Ranch Worker', 'Fisherman', 'Florist', 'Laborer/Worker', 'Landscaper', 'Landscaping/Nursery Worker', 'Logger', 'Mill Worker', 'Other', 'Ranger', 'Supervisor', 'Timber Grader/Scaler']
},
{
  label: 'Art/Design/Media',
  value: 'Art/Design/Media',
  occupations: ['Actor', 'Administrative Assistant', 'Announcer/Broadcaster', 'Artist/Animator', 'Author/Writer', 'Choreography/Dancer', 'Clerk', 'Composer/Director', 'Curator', 'Designer', 'Editor', 'Journalist/Reporter', 'Musician/Singer', 'Other', 'Photographer', 'Printer', 'Producer', 'Production Crew', 'Projectionist', 'Receptionist/Secretary', 'Ticket Sales/Usher']
},
{
  label: 'Banking/Finance/Real Estate',
  value: 'Banking/Finance/Real Estate',
  occupations: ['Accountant/Auditor', 'Administrative Assistant', 'Analyst', 'Appraiser - Real Estate', 'Bookkeeper', 'Branch Manager', 'Broker', 'Clerk', 'Collections', 'Consultant', 'Controller', 'CSR/Teller', 'Director/Administrator', 'Executive', 'Financial Advisor', 'Investment Banker', 'Investor', 'Loan/Escrow Processor', 'Manager - Credit/Loan', 'Manager - Portfolio/Production', 'Manager - Property', 'Other', 'Realtor', 'Receptionist/Secretary', 'Sales Agent/Representative', 'Trader, Financial Instruments', 'Underwriter']
},
{
  label: 'Business/Sales/Office',
  value: 'Business/Sales/Office',
  occupations: ['Account Executive', 'Administrative Assistant', 'Buyer', 'Cashier/Checker', 'Clerk-Office', 'Consultant', 'Customer Service Representative', 'Director/Administrator', 'Executive', 'H.R. Representative', 'Manager - Department/Store', 'Manager - District', 'Manager - Finance / Insurance', 'Manager - General Operations', 'Manager - H.R./Public Relations', 'Manager - Marketing/Sales', 'Manager/Supervisor - Office', 'Marketing Researcher', 'Messenger/Courier', 'Other', 'Receptionist/Secretary', 'Sales - Counter/Rental', 'Sales - Homebased', 'Sales - Manufacture Rep', 'Sales - Retail/Wholesale', 'Sales - Route/Vendor']
},
{
  label: 'Construction / Energy / Mining',
  value: 'Construction / Energy / Mining',
  occupations: ['Appraiser - Real Estate', 'Boiler Operator/Maker', 'Bricklayer/Mason', 'Carpenter', 'Carpet Installer', 'Concrete Worker', 'Construction - Project Manager', 'Construction Worker', 'Contractor', 'Crane Operator', 'Electrician/Linesman', 'Elevator Technician/Installer', 'Equipment Operator', 'Floor Layer/Finisher', 'Foreman/Supervisor', 'Handyman', 'Heat/Air Technician', 'Inspector', 'Laborer/Worker', 'Metalworker', 'Miner', 'Oil/Gas Driller/Rig Operator', 'Other', 'Painter', 'Plaster/Drywall/Stucco', 'Plumber', 'Roofer', 'Utility Worker', 'Welder']
},
{
  label: 'Disabled',
  value: 'Disabled',
  occupations: ['Disabled']
},
{
  label: 'Education/Library',
  value: 'Education/Library',
  occupations: ['Administrative Assistant', 'Audio-Visual Tech', 'Child/Daycare Worker', 'Clerk', 'Counselor', 'Graduate Teaching Assistant', 'Instructor-Vocation', 'Librarian/Curator', 'Other', 'Principal', 'Professor, College', 'Receptionist/Secretary', 'Superintendent', 'Teacher, College', 'Teacher, K-12', 'Teaching Assistant/Aide', 'Tutor']
},
{
  label: 'Engineer/Architect/Science/Math',
  value: 'Engineer/Architect/Science/Math',
  occupations: ['Actuary', 'Administrative Assistant', 'Analyst', 'Architect', 'Chemist', 'Clerk', 'Clinical Data Coordinator', 'Drafter', 'Engineer', 'Lab Assistant', 'Manager - Project', 'Manager - R&D', 'Mathematician', 'Other', 'Receptionist/Secretary', 'Research Program Director', 'Researcher', 'Scientist', 'Sociologist', 'Surveyor/Mapmaker', 'Technician']
},
{
  label: 'Food Service / Hotel Services',
  value: 'Food Service / Hotel Services',
  occupations: ['Baker', 'Bartender', 'Bellhop', 'Bus Person', 'Caterer', 'Chef', 'Concessionaire', 'Concierge', 'Cook - Restaurant/Cafeteria', 'Cook/Worker - Fast Food', 'Delivery Person', 'Desk Clerk', 'Dishwasher', 'Food Production/Packing', 'Host/Maitre d', 'Housekeeper/Maid', 'Manager', 'Other', 'Valet', 'Waiter/Waitress', 'Wine Steward']
},
{
  label: 'Government/Military',
  value: 'Government/Military',
  occupations: ['Accountant/Auditor', 'Administrative Assistant', 'Analyst', 'Attorney', 'Chief Executive', 'Clerk', 'Commissioner', 'Council Member', 'Director/Administrator', 'Enlisted Military Personnel (E1-E4)', 'Enlisted Military Personnel (E5-Officer)', 'Legislator', 'Mayor/City Manager', 'Meter Reader', 'NCO (E5-9)', 'Officer - Commissioned', 'Officer - Warrant', 'Other', 'Park Ranger', 'Planner', 'Postmaster', 'Receptionist/Secretary', 'Regulator', 'US Postal Worker']
},
{
  label: 'Homemaker (full-time)',
  value: 'Homemaker (full-time)',
  occupations: ['Homemaker (full-time)']
},
{
  label: 'Information Technology',
  value: 'Information Technology',
  occupations: ['Administrative Assistant', 'Analyst', 'Clerk', 'Director/Administrator', 'Engineer - Hardware', 'Engineer - Software', 'Engineer - Systems', 'Executive', 'Manager - Systems', 'Network Administrator', 'Other', 'Programmer', 'Project Coordinator', 'Receptionist/Secretary', 'Support Technician', 'Systems Security', 'Technical Writer', 'Web Developer']
},
{
  label: 'Insurance',
  value: 'Insurance',
  occupations: ['Accountant/Auditor', 'Actuarial Clerk', 'Actuary', 'Administrative Assistant', 'Agent/Broker', 'Analyst', 'Attorney', 'Claims Adjuster', 'Clerk', 'Commissioner', 'Customer Service Representative', 'Director/Administrator', 'Executive', 'Insurance CSR', 'Other', 'Product Manager', 'Receptionist/Secretary', 'Sales Representative', 'Underwriter']
},
{
  label: 'Legal/Law Enforcement/Security',
  value: 'Legal/Law Enforcement/Security',
  occupations: ['Airport Security Officer', 'Animal Control Officer', 'Attorney', 'Bailiff', 'Corrections Officer', 'Court Clerk/Reporter', 'Deputy Sheriff', 'Dispatcher', 'Examiner', 'Federal Agent/Marshall', 'Fire Chief', 'Fire Fighter/Supervisor', 'Gaming Officer/Investigator', 'Highway Patrol Officer', 'Judge/Hearing Officer', 'Legal Assistant/Secretary', 'Other', 'Paralegal/Law Clerk', 'Police Chief', 'Police Detective/Investigator', 'Police Officer/Supervisor', 'Private Investigator/Detective', 'Process Server', 'Security Guard', 'Sheriff']
},
{
  label: 'Medical/Social Services/Religion',
  value: 'Medical/Social Services/Religion',
  occupations: ['Administrative Assistant', 'Assistant - Medic/Dent/Vet', 'Chiropractor', 'Clergy', 'Clerk', 'Client Care Worker', 'Dental Hygienist', 'Dentist', 'Dietician', 'Doctor', 'Hospice Volunteer', 'Lab Assistant', 'Mortician', 'Nurse - C.N.A.', 'Nurse - LPN', 'Nurse - RN', 'Nurse Practitioner', 'Optometrist', 'Orthodontist', 'Other', 'Paramedic/E.M. Technician', 'Pharmacist', 'Physical Therapist', 'Psychologist', 'Receptionist/Secretary', 'Social Worker', 'Support Services', 'Technician', 'Therapist', 'Veterinarian']
},
{
  label: 'Other',
  value: 'Other',
  occupations: ['Other']
},
{
  label: 'Personal Care/Service',
  value: 'Personal Care/Service',
  occupations: ['Caregiver', 'Dry Cleaner/Laundry', 'Hair Stylist/Barber', 'Housekeeper', 'Manicurist', 'Masseuse', 'Nanny', 'Other', 'Pet Services', 'Receptionist/Secretary']
},
{
  label: 'Production / Manufacturing',
  value: 'Production / Manufacturing',
  occupations: ['Foreman/Supervisor', 'Administrative Assistant', 'Clerk', 'Factory Worker', 'Furniture Finisher', 'Inspector', 'Jeweler', 'Machine Operator', 'Other', 'Packer', 'Plant Manager', 'Printer/Bookbinder', 'Quality Control', 'Receptionist/Secretary', 'Refining Operator', 'Shoemaker', 'Tailor/Custom Sewer', 'Textile Worker', 'Upholsterer']
},
{
  label: 'Repair / Maintenance / Grounds',
  value: 'Repair / Maintenance / Grounds',
  occupations: ['Building Maintenance Engineer', 'Custodian/Janitor', 'Electrician', 'Field Service Technician', 'Handyman', 'Heat/Air Conditioner Repairman', 'Housekeeper/Maid', 'Landscape/Grounds Maintenance', 'Maintenance Mechanic', 'Mechanic', 'Other']
},
{
  label: 'Retired (full-time)',
  value: 'Retired (full-time)',
  occupations: ['Retired (full-time)']
},
{
  label: 'Sports/Recreation',
  value: 'Sports/Recreation',
  occupations: ['Activity/Recreational Assistant', 'Administrative Assistant', 'Agent', 'Athlete', 'Camp Counselor/Lead', 'Clerk', 'Coach', 'Concessionaire', 'Director, Program', 'Event Manager/Promoter', 'Life Guard', 'Manager - Fitness Club', 'Other', 'Park Ranger', 'Receptionist/Secretary', 'Sales - Ticket/Membership', 'Sports Broadcast/Journalist', 'Trainer/Instructor', 'Umpire/Referee']
},
{
  label: 'Student (full-time)',
  value: 'Student (full-time)',
  occupations: ['Graduate Student', 'High school', 'Other', 'Undergraduate', 'Student (full-time)']
},
{
  label: 'Travel / Transportation / Storage',
  value: 'Travel / Transportation / Storage',
  occupations: ['Administrative Assistant', 'Air Traffic Control', 'Airport Operations Crew', 'Bellhop/Porter', 'Clerk', 'Crane Loader/Operator', 'Dispatcher', 'Driver - Bus/Streetcar', 'Driver - Taxi/Limo', 'Driver - Truck/Delivery', 'Flight Attendant', 'Forklift Operator', 'Laborer', 'Longshoreman', 'Manager - Warehouse/District', 'Mate/Sailor', 'Other', 'Parking Lot Attendant', 'Pilot/Captain/Engineer', 'Railroad Worker', 'Receptionist/Secretary', 'Shipping/Receiving Clerk', 'Subway/Light Rail Operator', 'Ticket Agent', 'Transportation Specialist', 'Travel Agent']
},
{
  label: 'Unemployed',
  value: 'Unemployed',
  occupations: ['Unemployed']
},
];

const appliedIndustries = [
  {label: 'Administrative', value: 'Administrative', occupations: ['Administrative']},
  {label: 'Architect', value: 'Architect', occupations: ['Architect']},
  {label: 'Clergy', value: 'Clergy', occupations: ['Clergy']},
  {label: 'Certified Public Accountant', value: 'Certified Public Accountant', occupations: ['Certified Public Accountant']},
  {label: 'Dentist', value: 'Dentist', occupations: ['Dentist']},
  {label: 'Disabled/Unable to work', value: 'Disabled/Unable to work', occupations: ['Disabled/Unable to work']},
  {label: 'Engineer', value: 'Engineer', occupations: ['Engineer']},
  {label: 'Farmer', value: 'Farmer', occupations: ['Farmer']},
  {label: 'Flagged Occupation', value: 'Flagged Occupation', occupations: ['Flagged Occupation']},
  {label: 'Homemaker', value: 'Homemaker', occupations: ['Homemaker']},
  {label: 'Laborer', value: 'Laborer', occupations: ['Laborer']},
  {label: 'Lawyer', value: 'Lawyer', occupations: ['Lawyer']},
  {label: 'Military', value: 'Military', occupations: ['Military']},
  {label: 'Office, Sales', value: 'Office, Sales', occupations: ['Office, Sales']},
  {label: 'Other', value: 'Other', occupations: ['Other']},
  {label: 'Professional, Advanced degree', value: 'Professional, Advanced degree', occupations: ['Professional, Advanced degree']},
  {label: 'Professional, College degree', value: 'Professional, College degree', occupations: ['Professional, College degree']},
  {label: 'Physician', value: 'Physician', occupations: ['Physician']},
  {label: 'Professional Manager', value: 'Professional Manager', occupations: ['Professional Manager']},
  {label: 'Professor', value: 'Professor', occupations: ['Professor']},
  {label: 'Retired', value: 'Retired', occupations: ['Retired']},
  {label: 'Salaried', value: 'Salaried', occupations: ['Salaried']},
  {label: 'Scientist', value: 'Scientist', occupations: ['Scientist']},
  {label: 'School Teacher', value: 'School Teacher', occupations: ['School Teacher']},
  {label: 'Self-Employed', value: 'Self-Employed', occupations: ['Self-Employed']},
  {label: 'Skilled, Semi-Skilled', value: 'Skilled, Semi-Skilled', occupations: ['Skilled, Semi-Skilled']},
  {label: 'Student', value: 'Student', occupations: ['Student']},
  {label: 'Technical/Supervisory', value: 'Technical/Supervisory', occupations: ['Technical/Supervisory']},
  {label: 'Unknown', value: 'Unknown', occupations: ['Unknown']},
  {label: 'Unemployed', value: 'Unemployed', occupations: ['Unemployed']},
  {label: 'Unskilled', value: 'Unskilled', occupations: ['Unskilled']},
];

export const findOccupations = (
  industry,
  industryMapVendor?: IndustryMapVendor
) => {
  if (!industry) return [];

  let industries = ezlynxIndustries.map((opt) => opt.value);
  let industryList = ezlynxIndustries;

  if (industryMapVendor === 'PL Rating') {
    industries = plRatingIndustries.map((opt) => opt.value);
    industryList = plRatingIndustries;
  } else if (industryMapVendor === 'AppliedEpic') {
    industries = appliedEpicIndustries.map((opt) => opt.value);
    industryList = appliedEpicIndustries;
  } else if (industryMapVendor === 'Applied') {
    industries = appliedIndustries.map((opt) => opt.value);
    industryList = appliedIndustries;
  }

  const industryBestMatch = findBestMatch(industry, industries);

  if (
    industryBestMatch &&
    industryBestMatch.bestMatch &&
    industryBestMatch.bestMatch.target
  ) {
    const industry = industryList.find(
      (opt) => opt.value === industryBestMatch.bestMatch.target
    );
    if (!industry) {
      return [];
    }
    return industry.occupations;
  } else {
    return [];
  }
};

export const getIndustries = (industryMapVendor?: IndustryMapVendor) => {
  if (industryMapVendor === 'PL Rating') {
    return plRatingIndustries;
  } else if (industryMapVendor === 'AppliedEpic') {
    return appliedEpicIndustries;
  } else if (industryMapVendor === 'Applied') {
    return appliedIndustries;
  }
  return ezlynxIndustries;
};
